import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import React from 'react';

export type AppCheckboxProps = Omit<CheckboxProps, 'label'> & {
  label?: string | React.ReactNode;
  indeterminate?: boolean;
};

const AppCheckbox = React.forwardRef<HTMLInputElement, AppCheckboxProps>(
  ({ label, className, indeterminate, ...props }, ref) => {
    const checkboxRef = React.useRef<any>(null);

    // Sync indeterminate state with DOM element
    React.useEffect(() => {
      if (checkboxRef.current?.getElement) {
        const inputElement = checkboxRef.current.getElement();
        if (inputElement && inputElement.type === 'checkbox') {
          inputElement.indeterminate = !!indeterminate;
        }
      }
    }, [indeterminate]);

    return (
      <div className={`flex items-start gap-2 ${className || ''} ${indeterminate ? 'p-checkbox-indeterminate' : ''}`}>
        <Checkbox
          ref={checkboxRef}
          inputRef={ref}
          {...props}
        />
        {label && (
          <label className="text-sm cursor-pointer select-none">
            {label}
          </label>
        )}
      </div>
    );
  },
);
AppCheckbox.displayName = 'AppCheckbox';
export default AppCheckbox;
